export default __webpack_public_path__ + "0eb58301472de8cc2b0fc86853fc9873.jpg";